import ModalViewGroup from "./modal-view-group";

export default ModalViewGroup;